import { PlaybackSessionErrorType } from "@nrk/player-core/types.js";
import { PSAPIRequestErrorType, NonPlayableErrorType } from "@nrk/player-psapi-client";
var PlayerSourceErrorTypes = /* @__PURE__ */ ((PlayerSourceErrorTypes2) => {
  PlayerSourceErrorTypes2["MISSING_SOURCE"] = "MISSING_SOURCE";
  PlayerSourceErrorTypes2["SOURCE_NOT_SUPPORTED"] = "SOURCE_NOT_SUPPORTED";
  return PlayerSourceErrorTypes2;
})(PlayerSourceErrorTypes || {});
const PlayerErrorTypes = {
  ...PlaybackSessionErrorType,
  ...PSAPIRequestErrorType,
  ...NonPlayableErrorType,
  ...PlayerSourceErrorTypes
};
class PlayerError extends Error {
  type;
  cause;
  fatal;
  sessionInfo;
  constructor(type, fatal, cause, sessionInfo) {
    super(cause.message);
    Object.setPrototypeOf(this, PlayerError.prototype);
    this.type = type;
    this.fatal = fatal;
    this.cause = cause;
    this.name = "PlayerError";
    this.sessionInfo = sessionInfo;
  }
}
export {
  PlayerError,
  PlayerErrorTypes,
  PlayerSourceErrorTypes
};
